<template>
  <div class="overflow-y-hidden fill-height">
    <v-progress-linear :indeterminate="appLoading" color="primary"></v-progress-linear>
    <vue-pdf-embed class="mt-n1" :source="privacyPdfUrl" ref="pdf" :width="pageWidth" @rendered="iframeLoaded"/>
  </div>
</template>

<script lang="ts">
import {getPublicContentURl, getStage} from "../util";
import {Component, Vue} from "vue-facing-decorator";
import {useDisplay} from "vuetify";
import VuePdfEmbed from 'vue-pdf-embed'

@Component({
  components: {VuePdfEmbed}
})
export default class PrivacyPolicy extends Vue {
  private appLoading = false;
  private width = useDisplay().width;
  private lgAndUp = useDisplay().lgAndUp;

  private mounted() {
    this.appLoading = true;
  }

  private iframeLoaded() {
    this.appLoading = false;
  }

  private get pageWidth() {
    return this.lgAndUp ? Number(this.width) - 280 : this.width;
  }

  private get privacyPdfUrl() {
    return `${getPublicContentURl('themes/PrivacyPolicy.pdf')}`;
  }

}
</script>